/** @jsx jsx */
import { jsx } from "@emotion/react";
import {
  useTicker,
  useUserContext,
} from "@whitespace/gatsby-theme-smorgasbord/src/hooks";
import { MustacheDataProvider } from "@whitespace/gatsby-theme-wordpress-basic/src/components";
import PropTypes from "prop-types";
import { useEffect, useState } from "react";

import { apartmentContext } from "../contexts";

ApartmentProvider.propTypes = {
  children: PropTypes.node,
};

export default function ApartmentProvider({ children }) {
  const { Provider } = apartmentContext;

  const { user } = useUserContext();

  const [pending, setPending] = useState(true);
  const [error, setError] = useState(null);
  const [apartments, setApartments] = useState([]);
  const [selectedApartmentId, setSelectedApartmentId] = useState();

  const selectedApartment =
    apartments.find((apartment) => apartment.id === selectedApartmentId) ||
    apartments[0];

  const selectApartment = (apartmentId) => {
    setSelectedApartmentId(apartmentId);
  };

  const tick = useTicker(20 * 60 * 1000); // 20 minutes

  useEffect(async () => {
    if (user?.ssn) {
      setPending(true);
      try {
        const response = await fetch(`/api/fastapi/apartments`);
        if (response.ok) {
          const { data } = await response.json();
          let apartments = (data || []).map((apartment) => ({
            ...apartment,
            userIsAdmin: apartment.adminSsn === user.ssn,
          }));
          setApartments(apartments);
        } else {
          console.log(response);
          throw new Error(response.statusText);
        }
      } catch (error) {
        let { message } = error;
        setError({ message });
      }
    } else {
      setApartments([]);
    }
    setPending(false);
  }, [user?.ssn, tick]);

  return (
    <Provider
      value={{
        apartments,
        error,
        pending,
        selectApartment,
        selectedApartment,
      }}
    >
      <MustacheDataProvider
        data={{
          apartments,
          selectedApartment,
          apartmentProviderErrored: !!error,
        }}
      >
        {children}
      </MustacheDataProvider>
    </Provider>
  );
}
